<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-button
        v-if="fixedSaveDirect"
        :disabled="selectedRowKeys1.length == 0"
        type="primary"
        @click="add2"
        style="margin: 5px"
      >
        直接入库
      </a-button>
      <a-button v-if="currentExportDirect" type="primary" @click="exp2"> 数据导出 </a-button>
    </div>
    <div class="content_top">
      <a-select
        show-search
        allowClear
        v-model="quary.companyId"
        placeholder="公司名称"
        class="a_select_self margin_self"
        @change="handlecompany"
        @keyup.enter.native="query2"
      >
        <a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-input
        v-model="quary.spuSn"
        allowClear
        class="a_input_self margin_self"
        placeholder="品类编号"
        @keyup.enter.native="query2"
      />
      <a-input
        v-model="quary.name"
        allowClear
        class="a_input_self margin_self"
        placeholder="品类名称"
        @keyup.enter.native="query2"
      />
      <a-select
        show-search
        allowClear
        placeholder="类别"
        class="margin_self"
        v-model="quary.spuType"
        style="width: 120px"
        @keyup.enter.native="query2"
      >
        <a-select-option :value="item.value" v-for="(item, index) in goodsType" :key="index">
          {{ item.label }}
        </a-select-option>
      </a-select>
      <a-button type="primary" @click="query2"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
    </div>
    <div class="content_main_center" id="content_main_center">
      <a-table
        :columns="columns2"
        :data-source="newdata"
        :scroll="{ x: 1200, y: scroll_y }"
        bordered
        :pagination="false" :components="drag(columns2)"
        :row-selection="{ selectedRowKeys: selectedRowKeys1, onChange: onSelectChange1, type: 'radio' }"
      >
        
        <span slot="index" slot-scope="text, record, index">
          {{ (current2 - 1) * pageSize2 + index + 1 }}
        </span>
        <span slot="spu_type" slot-scope="text">
          {{ text ? operTypeMap[text].text : '' }}
        </span>
        <span slot="is_inspected" slot-scope="text">
          {{ instrumentMap[text] }}
        </span>
        <span slot="state" slot-scope="text">
          <template>
            <a-tag :color="colors[text]">
              {{ text ? statusMap[text] : '' }}
            </a-tag>
          </template>
        </span>
        <span slot="hazard_type" slot-scope="text">
          {{ text ? text.replace('其他;', '').replace(/;/g, '、') : '' }}
        </span>
        <span slot="storage_cond" slot-scope="text">
          {{ text ? text.replace('其他;', '').replace(/;/g, '、') : '' }}
        </span>
        <span slot="dept_id" slot-scope="text">
          {{ text ? deptMap[text].text : '' }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="details(record)">详情</a>
        </span>
      </a-table>
    </div>
    <div class="content_main_bot">
      <a-pagination
        v-model="current2"
        show-size-changer
        :page-size.sync="pageSize2"
        :total="total2"
        @showSizeChange="showSizeChange2"
        :pageSizeOptions="['10', '20', '30', '50']"
        @change="onShowSizeChange2"
      />
    </div>
    <a-modal title="固定资产入库-新增" v-model="visible" on-ok="handleOk" width="880px">
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="preservation"> 保存 </a-button>
      </template>
      <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol" ref="formMode">
        <a-row>
          <a-col :span="12">
            <a-form-item label="资产类别">
              <a-select
                allowClear
                v-decorator="['asset_type', { rules: [{ required: true, message: '请填写资产类别!' }] }]"
                placeholder="请选择"
              >
                <a-select-option :key="index" v-for="(item, index) in assettype" :value="item.dictCode">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="物品状态">
              <a-select
                allowClear
                v-decorator="['state', { rules: [{ required: true, message: '请填写物品状态!' }] }]"
                placeholder="请选择"
                @change="statechange"
              >
                <a-select-option :key="index" v-for="(item, index) in statusMap" :value="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="物品名称">
              <a-input
                allowClear
                v-decorator="['name', { rules: [{ required: true, message: '请填写物品名称!' }] }]"
                placeholder="请输入"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采购时间">
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                allowClear
                v-decorator="['purchase_time', { rules: [{ required: true, message: '请填写采购时间!' }] }]"
                placeholder="请输入"
                style="width: 277px"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否仪器" class="form_item">
					<a-select @change="instrtime($event)" allowClear v-decorator="['is_instrument', { rules: [{ required: true, message: '请填写是否仪器!' }] }]"
					 placeholder="请选择">
						<a-select-option :value="1"> 是 </a-select-option>
						<a-select-option :value="0"> 否 </a-select-option>
					</a-select>
				</a-form-item> -->
        <a-row>
          <a-col :span="12">
            <a-form-item label="采购价格">
              <a-input allowClear v-decorator="['purchase_price']" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="物品编号">
              <a-select
                show-search
                v-decorator="['asset_sn', { rules: [{ required: true, message: '请填写物品编号!' }] }]"
                placeholder="请输入"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="handleSearchAssetSn"
                @change="handleChangeAssetSn"
                autocomplete="off"
              >
                <a-select-option v-for="(assetInfo, idx) in asset_sn_lis" :value="idx" :key="idx">
                  {{ assetInfo.asset_sn }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="供 应 商 ">
              <a-input allowClear v-decorator="['dealer']" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="规格型号">
              <a-input
                allowClear
                v-decorator="['model', { rules: [{ required: true, message: '请填写规格型号!' }] }]"
                placeholder="请输入"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任部门">
              <a-tree-select
                :treeData="deptTree"
                placeholder="负责部门"
                v-decorator="['dept_id', { rules: [{ required: true, message: '请输入责任部门!' }] }]"
                treeDefaultExpandAll
                @change="leaderid($event)"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="责 任 人 ">
              <a-input
                allowClear
                v-decorator="['charger', { rules: [{ required: true, message: '请填写责任人!' }] }]"
                placeholder="请输入"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="物品数量">
              <a-input allowClear v-model="num" placeholder="请输入" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="入 库 人 ">
              <a-input
                allowClear
                v-decorator="['operator', { rules: [{ required: true, message: '请输入入库人!' }] }]"
                placeholder="请输入"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="准用说明">
              <a-input allowClear v-decorator="['permit']" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="保 管 人 ">
              <a-input
                allowClear
                v-decorator="['keeper', { rules: [{ required: true, message: '请输入保管人!' }] }]"
                placeholder="请输入"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="生产厂家">
              <a-input allowClear v-decorator="['manufacturer']" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="出厂编号">
              <a-input allowClear v-decorator="['factory_sn']" placeholder="请输入" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="到货日期">
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                allowClear
                v-decorator="['arrive_time']"
                placeholder="请输入"
                style="width: 277px"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="最后检定时间">
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                allowClear
                v-decorator="['inspect_time']"
                placeholder="请输入"
                style="width: 277px"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="精　　度">
              <a-input allowClear v-decorator="['precisions']" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="检定结果">
              <a-input allowClear v-decorator="['inspect_result']" placeholder="请输入" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="备　　注">
              <a-input allowClear v-decorator="['notes']" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="上传附件">
              <a-upload
                v-if="(form.getFieldValue('asset_sn') != undefined || '') && form.getFieldValue('dept_id') && is_uplaod"
                action="https://coa.anliantest.com/oaProxyApi/proxyPython/file/upload"
                :headers="headers"
                name="file"
                :remove="removeFile"
                :default-file-list="defaultFileList"
                @preview="previewFile"
                :data="{ type: 'asset', file_name: file_name, asset_sn: asset_sn, dept_id: dept_id }"
                method="post"
                :beforeUpload="beforeUpload"
                @change="handleChange"
              >
                <a-button> <a-icon type="upload" /> 上传文件 </a-button>
              </a-upload>
              <el-row>
                <div style="font-size: 13px; color: red">仅支持pdf文件上传(﹤=10MB)</div>
              </el-row>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal title="流动资产入库-新增" v-model="Warevisible" width="70%" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="WareCancel"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="Wareprese"> 入库 </a-button>
      </template>
      <a-form-model :model="form2" ref="form2Ref" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="公司名称"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="company_name"
              :rules="{ required: true, message: '请填写公司名称!', trigger: 'change' }"
            >
              <a-input allowClear v-model="form2.company_name" disabled />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="品类编号"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="spu_sn"
              :rules="{ required: true, message: '请填写品类编号', trigger: 'change' }"
            >
              <a-input allowClear v-model="form2.spu_sn" disabled />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="物品名称"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="name"
              :rules="{ required: true, message: '请填写物品名称!', trigger: 'change' }"
            >
              <a-input allowClear v-model="form2.name" placeholder="请输入物品名称" disabled />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="类别"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="spu_type"
              :rules="{ required: true, message: '请选择类别!', trigger: 'change' }"
            >
              <a-select allowClear disabled v-model="form2.spu_type" placeholder="请选择">
                <a-select-option :key="index" v-for="(item, index) in assettype" :value="item.dictCode">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="规格型号"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="model"
              :rules="{ required: true, message: '请填写规格型号!', trigger: 'change' }"
            >
              <a-input allowClear disabled v-model="form2.model" placeholder="请输入型号或名称" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="是否已检定"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="is_inspected"
              :rules="{ required: true, message: '请填写规格型号!', trigger: 'change' }"
            >
              <a-select allowClear disabled v-model="form2.is_inspected" placeholder="请选择">
                <a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="Number(index)">
                      {{ item }}
                    </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="生产批号"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="factory_batch"
            >
              <a-input allowClear v-model="form2.factory_batch" placeholder="请输入生产批号" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="定　　值" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="stable_lmt">
              <a-input allowClear v-model="form2.stable_lmt" placeholder="请输入定值" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="存放位置" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="storage_loc">
              <a-input allowClear v-model="form2.storage_loc" placeholder="请输入存放位置" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="采购均价"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="price"
            >
              <a-input type="number" allowClear disabled v-model="form2.price" placeholder="请输入采购均价" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="入库数量"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="amount"
              :rules="{ required: true, message: '请输入入库数量!', trigger: 'change' }"
            >
              <a-input
                @change="changeamount"
                type="number"
                allowClear
                v-model="form2.amount"
                placeholder="请输入采购数量"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="物品单位" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="unit">
              <a-input allowClear disabled v-model="form2.unit" placeholder="请输入物品单位" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="采购总额"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="value"
              :rules="{ required: true, message: '请输入采购总额!', trigger: 'change' }"
            >
              <a-input
                @change="changeamount"
                type="number"
                allowClear
                v-model="form2.value"
                placeholder="请输入采购总额"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="采购单价"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="purchase_price"
              :rules="{ required: true, message: '请输入采购单价!', trigger: 'change' }"
            >
              <a-input allowClear type="number" disabled v-model="form2.purchase_price" placeholder="请输入采购单价" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="供 应 商 " :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="dealer">
              <a-input allowClear v-model="form2.dealer" placeholder="请输入供应商" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <!-- 生产批号 -->
          <a-col :span="8">
            <a-form-model-item label="生产厂家 " :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="dealer">
              <a-input allowClear v-model="form2.manufacturer" placeholder="请输入生产厂家" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="采购时间"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="purchase_time"
              :rules="{ required: true, message: '请输入采购时间!', trigger: 'change' }"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                :disabled-date="disabledDate"
                allowClear
                v-model="form2.purchase_time"
                placeholder="请输入采购时间"
                style="width: 209px"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="到货时间" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="arrive_time">
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                :disabled-date="disabledDate"
                allowClear
                placeholder="请输入到货时间"
                v-model="form2.arrive_time"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="检定周期"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="inspect_cycle"
            >
              <a-input allowClear v-model="form2.inspect_cycle" placeholder="请输入检定周期" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="检定日期"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="inspect_time"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                :disabled-date="disabledDate"
                allowClear
                v-model="form2.inspect_time"
                placeholder="请输入检定日期"
                style="width: 209px"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="检定结果"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="inspect_result"
            >
              <a-input allowClear v-model="form2.inspect_result" placeholder="请输入检定结果" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="入 库 人 " :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="operator">
              <a-input allowClear disabled v-model="form2.operator" placeholder="请输入入库人" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="备　　注" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" prop="notes">
              <a-input allowClear v-model="form2.notes" placeholder="请输入备注" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <!-- <span>{{form2.storage_cond}}</span> -->
          <a-col :span="24">
            <a-form-model-item
              label="是否为制毒、制爆"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="hazard_type"
              :rules="{ required: true, message: '请选择!', trigger: 'change' }"
            >
              <a-checkbox-group disabled v-model="form2.hazard_type" :options="checkout" @change="checkoutChange2" />
              <a-input v-model="elss" style="width: 200px" disabled />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="存放条件"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
              prop="storage_cond"
              :rules="{ required: true, message: '请选择!', trigger: 'change' }"
            >
              <a-checkbox-group disabled v-model="form2.storage_cond" :options="condition" @change="conditionChange2" />
              <a-input v-model="others" style="width: 200px" disabled />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <a-modal title="流动资产入库-详情" :visible="detailsvisible" @ok="detailsOk" @cancel="detailsCancel" width="880px">
      <template slot="footer">
        <a-button key="back" @click="detailsOk"> 取消 </a-button>
      </template>
      <a-form-model :model="detailsrow" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
        <a-row>
          <!-- <a-col :span="12">
						<a-form-model-item label="资产类别">
							<span>{{ detailsrow.spu_type ? operTypeMap[detailsrow.spu_type].text : '' }}</span>
						</a-form-model-item>
					</a-col> -->
          <a-col :span="12">
            <a-form-model-item label="品类编号">
              <span>{{ detailsrow.spu_sn }}</span>
            </a-form-model-item>
          </a-col>
          <!-- </a-row>
				<a-row> -->
          <a-col :span="12">
            <a-form-model-item label="品类名称">
              <span>{{ detailsrow.name }}</span>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
						<a-form-model-item label="物品数量">
							<span>{{ detailsrow.amount }}</span>
						</a-form-model-item>
					</a-col> -->
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="规格型号">
              <span>{{ detailsrow.model }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="数量">
              <span>{{ detailsrow.storage_num }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <a-row>
					<a-col :span="12">
						<a-form-model-item label="规格型号">
							<span>{{ detailsrow.model }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品单位">
							<span>{{ detailsrow.unit }}</span>
						</a-form-model-item>
					</a-col>
				</a-row> -->
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="采购均价">
              <span>{{ detailsrow.price }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="单位">
              <span>{{ detailsrow.unit }}</span>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
						<a-form-model-item label="物品状态">
							<span>{{ detailsrow.state ? statusMap[detailsrow.state] : '' }}</span>
						</a-form-model-item>
					</a-col> -->
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="类别">
              <span>{{detailsrow.spu_type_name}}</span>
              <!-- <span> {{ asset_type ? goodsTypeObj[asset_type] : '' }}</span> -->
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否已检定">
              <span>{{ detailsrow.is_inspected_name }}</span>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
						<a-form-model-item label="采购订单id">
							<span>{{ detailsrow.order_id }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="公司名称">
							<span>{{ detailsrow.company_name }}</span>
						</a-form-model-item>
					</a-col> -->
        </a-row>
        <!-- <a-row>
					<a-col :span="12">
						<a-form-model-item label="采购时间">
							<span>{{ detailsrow.purchase_time }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购金额">
							<span>{{ detailsrow.value }}</span>
						</a-form-model-item>
					</a-col>
				</a-row> -->
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="公司名称">
              <span>{{ detailsrow.company_name }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="备注">
              <span>{{ detailsrow.notes }}</span>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
						<a-form-model-item label="采购数量">
							<span>{{ detailsrow.amount }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购单价">
							<span>{{ detailsrow.purchase_price }}</span>
						</a-form-model-item>
					</a-col> -->
        </a-row>
        <!-- <a-row>
					<a-col :span="12">
						<a-form-model-item label="存放条件">
							<span>{{
						  detailsrow.storage_cond ? detailsrow.storage_cond.split(';').join('、').replace('、其他', '') : ''
						}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="存放位置">
							<span>{{ detailsrow.storage_loc }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="供 应 商 ">
							<span>{{ detailsrow.dealer }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="生产厂家">
							<span>{{ detailsrow.manufacturer }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="生产批号">
							<span>{{ detailsrow.factory_batch }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="使用人(保管人)">
							<span>{{ detailsrow.keeper }}</span>
						</a-form-model-item>
					</a-col>
				</a-row> -->
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="录入时间">
              <span>{{ detailsrow.createTime }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="录入人">
              <span>{{ detailsrow.createBy }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="维护时间">
              <span>{{ detailsrow.updateTime }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="维护人">
              <span>{{ detailsrow.updateBy }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="是否为制毒、制爆">
              <span>{{
                detailsrow.hazard_type ? detailsrow.hazard_type.split(';').join('、').replace('、其他', '') : ''
              }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="存放条件">
              <span>{{
                detailsrow.storage_cond ? detailsrow.storage_cond.split(';').join('、').replace('、其他', '') : ''
              }}</span>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
						<a-form-model-item label="负责部门">
							<span>{{ detailsrow.dept_id ? deptMap[detailsrow.dept_id].text : '' }}</span>
						</a-form-model-item>
					</a-col> -->
        </a-row>
        <!-- <a-row>
					<a-col :span="12">
						<a-form-model-item label="是否已检定">
							<span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="责 任 人 ">
							<span>{{ detailsrow.charger }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购时间">
							<span>{{ detailsrow.purchase_time }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="到货时间">
							<span>{{ detailsrow.arrive_time }}</span>
						</a-form-model-item>
					</a-col>

				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定周期">
							<span>{{ detailsrow.inspect_cycle }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定日期">
							<span>{{ detailsrow.inspect_time }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定结果">
							<span>{{ detailsrow.inspect_result }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备　　注">
							<span>{{ detailsrow.notes }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定结果" v-if="detailsrow.is_inspected==1">
							<span>{{ detailsrow.inspect_result }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定周期" v-if="detailsrow.is_inspected==1">
							<span>{{ detailsrow.inspect_cycle }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定日期" v-if="detailsrow.is_inspected==1">
							<span>{{ detailsrow.inspect_time }}</span>
						</a-form-model-item>
					</a-col>
				</a-row> -->
      </a-form-model>
    </a-modal>
    <!-- <a-modal title="请选择物品" v-model="changevisible" width="1200px">
			<template slot="footer">
				<a-button key="back" @click="changefalse"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="surechange"> 确定 </a-button>
			</template>
			<a-input v-model="change.id" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" />
			<a-input v-model="change.name" allowClear class="a_input_self margin_self" placeholder="请输入物品名称" />
			<a-button type="primary" style="margin: 5px" @click="serchall"> 查询 </a-button>
			<a-table :data-source="changedata" bordered rowKey="id"
				:row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
				:pagination="pagination" @change="handleTableChange">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">{{ (pagination.current-1)*10+index+1 }}</template>
				</a-table-column>
				<a-table-column key="company_name" title="公司名称" data-index="company_name" />
				<a-table-column key="spu_sn" title="物品编号" data-index="spu_sn" />
				<a-table-column key="name" title="物品名称" data-index="name" />
				<a-table-column key="model" title="规格型号" data-index="model" />
				<a-table-column key="is_inspected" title="是否已检定" data-index="is_inspected">
					<template slot-scope="text">
						{{ instrumentMap[text] }}
					</template>
				</a-table-column>
				<a-table-column key="create_by" title="录入人" data-index="create_by" />
			</a-table>
		</a-modal> -->
  </div>
</template>

<script>
import { limitCompany } from '@/utils/limitCompany'
import { downLoadXlxs2 } from '@/utils/index'
import { tree_all, enableParent } from '@/api/purchase'
import tableDragResize from '@/mixins/tableDragResize'
import {
  get_checkout,
  purchase,
  checkin,
  assetget_list2,
  dict,
  upload,
  dept_get,
  // get_dept_tree,
  remove,
  // sku_spu_get_list,
  // get_latest,
  get_sku_xlsx,
  listSku,
  consumablesSku,
  consumablesList,
} from '@/api/assetmenag'
import { getDeptListEnable } from '@/api/system'
import { checkPermission } from '@/utils/permissions'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { get_users2, get_dict } from '@/utils/unit_axios'
const deptMap = {}
const columns = [
  {
    title: '资产类别',
    dataIndex: 'asset_type',
    scopedSlots: {
      customRender: 'asset_type',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'asset',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
    width: 150,
    ellipsis: true,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 300,
    ellipsis: true,
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    scopedSlots: {
      customRender: 'state',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
    width: 150,
    ellipsis: true,
  },
  {
    title: '采购时间',
    dataIndex: 'purchase_time',
    key: 'purchase_time',
    width: 150,
    ellipsis: true,
  },
  {
    title: '采购价格',
    dataIndex: 'purchase_price',
    key: 'purchase_price',
    width: 150,
    ellipsis: true,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    width: 150,
    ellipsis: true,
  },
  {
    title: '供应商',
    dataIndex: 'dealer',
    key: 'dealer',
    width: 150,
    ellipsis: true,
  },
  {
    title: '保管人',
    dataIndex: 'keeper',
    key: 'keeper',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 150,
  },
]
const checkout = ['易制毒', '易制爆', '剧毒', '其他']
const condition = ['常温', '冷冻', '冷藏', '避光', '其他']
const columns2 = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '公司名称',
    dataIndex: 'company_name',
    key: 'company_name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '品类编号',
    dataIndex: 'spu_sn',
    key: 'spu_sn',
    scopedSlots: {
      customRender: 'spu_sn',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '类型',
    dataIndex: 'spu_type_name',
    key: 'spu_type_name',
    scopedSlots: {
      customRender: 'spu_type_name',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '品类名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    ellipsis: true,
  },

  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 200,
    ellipsis: true,
  },
  {
    title: '数量',
    dataIndex: 'storage_num',
    key: 'storage_num',
    width: 150,
    ellipsis: true,
  },
  {
    title: '单位',
    dataIndex: 'unit',
    key: 'unit',
    width: 150,
    ellipsis: true,
  },
  //采购均价
  {
    title: '采购均价',
    dataIndex: 'price',
    key: 'price',
    width: 150,
    ellipsis: true,
  },
  {
    title: '是否已检定',
    dataIndex: 'is_inspected',
    key: 'is_inspected',
    scopedSlots: {
      customRender: 'is_inspected',
    },
    width: 150,
    ellipsis: true,
  },
  // {
  // 	title: '物品状态',
  // 	dataIndex: 'state',
  // 	key: 'state',
  // 	scopedSlots: {
  // 		customRender: 'state',
  // 	},
  // 	width: 150,
  // 	ellipsis: true,
  // },
  {
    title: '是否为制毒、制爆',
    dataIndex: 'hazard_type',
    key: 'hazard_type',
    scopedSlots: {
      customRender: 'hazard_type',
    },
    width: 200,
    ellipsis: true,
  },
  // {
  // 	title: '定值',
  // 	dataIndex: 'stable_lmt',
  // 	key: 'stable_lmt',
  // 	width: 150,
  // 	ellipsis: true,
  // }, {
  // 	title: '生产批号',
  // 	dataIndex: 'factory_batch',
  // 	key: 'factory_batch',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '存放位置',
  // 	dataIndex: 'storage_loc',
  // 	key: 'storage_loc',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  {
    title: '存放条件',
    dataIndex: 'storage_cond',
    key: 'storage_cond',
    scopedSlots: {
      customRender: 'storage_cond',
    },
    width: 300,
    ellipsis: true,
  },
  {
    title: '备注',
    dataIndex: 'notes',
    key: 'notes',
    width: 150,
    ellipsis: true,
  },
  //录入人
  {
    title: '录入人',
    dataIndex: 'createBy',
    key: 'createBy',
    width: 150,
    ellipsis: true,
  },
  //录入时间
  {
    title: '录入时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 150,
    ellipsis: true,
  },
  // 维护人
  {
    title: '维护人',
    dataIndex: 'updateBy',
    key: 'updateBy',
    width: 150,
    ellipsis: true,
  },
  // 维护时间
  {
    title: '维护时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 150,
    ellipsis: true,
  },
  // {
  // 	title: '采购时间',
  // 	dataIndex: 'purchase_time',
  // 	key: 'purchase_time',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '采购单价',
  // 	dataIndex: 'purchase_price',
  // 	key: 'purchase_price',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '采购总额',
  // 	dataIndex: 'value',
  // 	key: 'value',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '到货日期',
  // 	dataIndex: 'arrive_time',
  // 	key: 'arrive_time',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '供应商',
  // 	dataIndex: 'dealer',
  // 	key: 'dealer',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '生产厂家',
  // 	dataIndex: 'manufacturer',
  // 	key: 'manufacturer',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '检定日期',
  // 	dataIndex: 'inspect_time',
  // 	key: 'inspect_time',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '检定结果',
  // 	dataIndex: 'inspect_result',
  // 	key: 'inspect_result',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '检定周期',
  // 	dataIndex: 'inspect_cycle',
  // 	key: 'inspect_cycle',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '责任部门',
  // 	dataIndex: 'dept_id',
  // 	key: 'dept_id',
  // 	scopedSlots: {
  // 		customRender: 'dept_id',
  // 	},
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '责任人',
  // 	dataIndex: 'charger',
  // 	key: 'charger',
  // 	width: 150,
  // 	ellipsis: true,
  // },
  // {
  // 	title: '使用人(保管人)',
  // 	dataIndex: 'keeper',
  // 	key: 'keeper',
  // 	width: 150,
  // 	ellipsis: true,
  // },

  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    fixed: 'right',
    width: 150,
  },
]

// const rowSelection = {
// 	onChange: (selectedRowKeys, selectedRows) => {
// 		console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
// 	},
// 	onSelect: (record, selected, selectedRows) => {
// 		console.log(record, selected, selectedRows)
// 	},
// 	onSelectAll: (selected, selectedRows, changeRows) => {
// 		console.log(selected, selectedRows, changeRows)
// 	},
// }

export default {
  mixins: [tableDragResize],
  data() {
    return {
      selectedRowKeys1: [],
      rowData: [],
      quary: {
        spuSn: '',
        companyId: undefined,
        assetSn: '',
        name: '',
        spuType: undefined,
      },
      companyList: [],
      is_uplaod: false,
      Warevisible: false,
      changevisible: false,
      plainOptions: [],
      change: {
        name: '',
        id: '',
      },
      elss: '',
      others: '',
      checkout,
      newdata: [],
      condition,
      fileListLoad: [],
      deptlistInput: [],
      statusMap: '',
      fileList: [],
      defaultFileList: [],
      asset_sn_lis: [],
      select_asset_index: undefined,
      file_name: '',
      index: undefined,
      statenum: undefined,
      asset_sn: '',
      dept_id: '',
      arr_file: [],
      file_type: '',
      headers: {},
      scroll_y: 150,
      operTypeMap: {},
      pageSize: 10,
      current: 1,
      total: 0,
      pageSize2: 10,
      current2: 1,
      total2: 0,
      deptTree: [],
      this_dept_id: '',
      assetlist: [],
      deptMap,
      // spuid: [],
      num: 1,
      visible: false,
      visible2: false,
      detailsvisible: false,
      detailsrow: {},
      data2: [],
      changedata: [],
      columns,
      columns2,
      boo: '',
      name: '',
      asset_sn: '',
      checkList: [],
      checkList2: [],
      state: undefined,
      name2: '',
      name3: '',
      start_date: '',
      end_date: '',
      loading: false,
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      assettype: [],
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      labelCol2: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol2: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      leader: '',
      selectedRowKeys: [],
      // companylist: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      spu_data: {},
      currentExportDirect: checkPermission('assetmenag:direct:currentExport'),
      currentInfoDirect: checkPermission('assetmenag:direct:currentInfo'),
      fixedExportDirect: checkPermission('assetmenag:direct:fixedExport'),
      fixedSaveDirect: checkPermission('assetmenag:direct:fixedSave'),
      fixedInfoDirect: checkPermission('assetmenag:direct:fixedInfo'),
    }
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
    assets: {
      get() {
        return this.detailsrow.asset_type ? this.operTypeMap[this.detailsrow.asset_type].text : ''
      },
      set(value) {
        this.detailsrow.asset_type = value
      },
    },
    states: {
      get() {
        return this.detailsrow.state ? this.statusMap[this.detailsrow.state] : ''
      },
      set(value) {
        this.detailsrow.state = value
      },
    },
    isinstrument: {
      get() {
        return this.detailsrow.is_instrument ? this.instrumentMap[this.detailsrow.is_instrument] : ''
      },
      set(value) {
        this.detailsrow.is_instrument = value
      },
    },
    isinspected: {
      get() {
        return this.detailsrow.is_inspected ? this.instrumentMap[this.detailsrow.is_inspected] : ''
      },
      set(value) {
        this.detailsrow.is_inspected = value
      },
    },
    hazard_types: {
      get() {
        return this.detailsrow.hazard_type ? this.detailsrow.hazard_type.split(';') : ''
      },
      set(value) {
        this.detailsrow.hazard_type = value
      },
    },
    storage_conds: {
      get() {
        return this.detailsrow.storage_cond ? this.detailsrow.storage_cond.split(';') : ''
      },
      set(value) {
        this.detailsrow.storage_cond = value
      },
    },
  },
  filters: {
    operTypeFilter(type) {
      return operTypeMap[type].text
    },
    deptFilter(type) {
      return deptMap[type].text
    },
  },

  created() {
    limitCompany().then((res) => {
      res.forEach((item) => {
        if (item.deptId) {
          this.companyList.push(item)
        }
      })
    })

    // this.getCompany()
    get_dict('goodStatus', (res) => {
      console.log(res)
      this.statusMap = res
    })
    dict({
      pageNum: 1,
      pageSize: 10,
      dictType: 'assets_type',
    }).then((res) => {
      this.assettype = res.rows
      this.assettype.map((d) => {
        this.operTypeMap[d.dictCode] = {
          text: d.dictLabel,
        }
      })
    })
    // sku_spu().then((res) => {
    // 	this.spuid = res.data
    // })
    // get_dept_tree().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    getDeptListEnable().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, min)
        this.deptTree.map((d) => {
          if (d.hasOwnProperty('children')) {
            d.children.map((b) => {
              if (b.hasOwnProperty('children')) {
                b.children.map((a) => {
                  deptMap[a.key] = {
                    text: a.title,
                  }
                })
              }
              deptMap[b.key] = {
                text: b.title,
              }
              deptMap[d.key] = {
                text: d.title,
              }
            })
          } else {
            deptMap[d.key] = {
              text: d.title,
            }
          }
        })
        this.expandedKeys = data.map((m) => m.parentId)
        this.dataList = data.map((m) => {
          return {
            key: m.deptId,
            title: m.deptName,
          }
        })
      }
    })
    console.log(this.deptMap, 121)
    this.get_checkin()
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height()+20
      }, 1000)
    })
  },
  watch: {
    form2() {
      console.log(this.form2, 'form2=============================')
    },
  },
  methods: {
    //选中某一项
    onSelectChange1(selectedRowKeys1, val) {
      this.rowData = []
      this.selectedRowKeys1 = []
      console.log(selectedRowKeys1, val, 'valvalvalvalvalvalvalvalval')
      this.selectedRowKeys1 = selectedRowKeys1
      this.rowData = val[0]
      console.log(this.rowData, 'this.rowData==============')
    },
    //获得公司名称companyList
    // getCompany() {

    //   enableParent().then((res) => {
    //     var arry = []
    //     var array1 = {}
    //     res.rows.forEach((item) => {
    //       if (item.isCompany == 1) {
    //         if (arry.length != 0) {
    //           arry.forEach((item1) => {
    //             if (item1.deptId != item.deptId) {
    //               array1 = {
    //                 deptId: item.deptId,
    //                 title: item.deptName,
    //               }
    //             }
    //           })
    //           arry.push(array1)
    //         } else {
    //           array1 = {
    //             deptId: item.deptId,
    //             title: item.deptName,
    //           }
    //           arry.push(array1)
    //         }
    //       }
    //     })
    //     this.companyList = arry
    //   })
    // tree_all().then(res=>{
    // this.companyList = res.data[0]
    // })
    // },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    onSelectChange(selectedRowKeys) {
      console.log(selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    surechange() {
      this.changevisible = false
      var _this = this
      this.selectedRowKeys.forEach((item) => {
        // get_latest({
        // 	spu_id: item
        // }).then(res => {
        // 	this.form2.resetFields()
        // 	this.spu_data = res.data
        // 	this.spu_data.spu_id = item
        // 	if (res.data.company_name) {
        // 		this.form2.setFieldsValue({
        // 			company_name: res.data.company_name,
        // 		})
        // 	}
        // 	if (res.data.spu_type) {
        // 		this.form2.setFieldsValue({
        // 			spu_type: res.data.spu_type,
        // 		})
        // 	}
        // 	if (res.data.name) {
        // 		this.form2.setFieldsValue({
        // 			name: res.data.name,
        // 		})
        // 	}
        // 	if (res.data.model) {
        // 		this.form2.setFieldsValue({
        // 			model: res.data.model,
        // 		})
        // 	}
        // 	if (res.data.state) {
        // 		this.form2.setFieldsValue({
        // 			state: res.data.state + '',
        // 		})
        // 	}
        // 	if (res.data.stable_lmt) {
        // 		this.form2.setFieldsValue({
        // 			stable_lmt: res.data.stable_lmt,
        // 		})
        // 	}
        // 	if (res.data.factory_batch) {
        // 		this.form2.setFieldsValue({
        // 			factory_batch: res.data.factory_batch,
        // 		})
        // 	}
        // 	if (res.data.storage_loc) {
        // 		this.form2.setFieldsValue({
        // 			storage_loc: res.data.storage_loc,
        // 		})
        // 	}
        // 	if (res.data.is_inspected !== null) {
        // 		this.form2.setFieldsValue({
        // 			is_inspected: res.data.is_inspected + '',
        // 		})
        // 	}
        // 	if (res.data.inspect_result) {
        // 		this.form2.setFieldsValue({
        // 			inspect_result: res.data.inspect_result,
        // 		})
        // 	}
        // 	if (res.data.inspect_time) {
        // 		this.form2.setFieldsValue({
        // 			inspect_time: res.data.inspect_time,
        // 		})
        // 	}
        // 	if (res.data.inspect_cycle) {
        // 		this.form2.setFieldsValue({
        // 			inspect_cycle: res.data.inspect_cycle,
        // 		})
        // 	}
        // 	if (res.data.price) {
        // 		this.form2.setFieldsValue({
        // 			price: res.data.price,
        // 		})
        // 	}
        // 	if (res.data.keeper) {
        // 		this.form2.setFieldsValue({
        // 			keeper: res.data.keeper,
        // 		})
        // 	}
        // 	if (res.data.dept_id) {
        // 		this.form2.setFieldsValue({
        // 			dept_id: res.data.dept_id,
        // 		})
        // 	}
        // 	if (res.data.charger) {
        // 		this.form2.setFieldsValue({
        // 			charger: res.data.charger,
        // 		})
        // 	}
        // 	if (res.data.value) {
        // 		this.form2.setFieldsValue({
        // 			value: res.data.value,
        // 		})
        // 	}
        // 	if (res.data.amount) {
        // 		this.form2.setFieldsValue({
        // 			amount: res.data.amount,
        // 		})
        // 	}
        // 	if (res.data.unit) {
        // 		this.form2.setFieldsValue({
        // 			unit: res.data.unit,
        // 		})
        // 	}
        // 	if (res.data.purchase_price) {
        // 		console.log(res.data.purchase_price)
        // 		this.form2.setFieldsValue({
        // 			purchase_price: res.data.purchase_price,
        // 		})
        // 	}
        // 	if (res.data.purchase_time) {
        // 		this.form2.setFieldsValue({
        // 			purchase_time: res.data.purchase_time,
        // 		})
        // 	}
        // 	if (res.data.dealer) {
        // 		this.form2.setFieldsValue({
        // 			dealer: res.data.dealer,
        // 		})
        // 	}
        // 	if (res.data.manufacturer) {
        // 		this.form2.setFieldsValue({
        // 			manufacturer: res.data.manufacturer,
        // 		})
        // 	}
        // 	if (res.data.arrive_time) {
        // 		this.form2.setFieldsValue({
        // 			arrive_time: res.data.arrive_time,
        // 		})
        // 	}
        // 	if (res.data.notes) {
        // 		this.form2.setFieldsValue({
        // 			notes: res.data.notes,
        // 		})
        // 	}
        // 	if (res.data.storage_loc) {
        // 		this.form2.setFieldsValue({
        // 			storage_loc: res.data.storage_loc,
        // 		})
        // 	}
        // 	this.$nextTick(() => {
        // 		this.companylist.forEach((item) => {
        // 			if (item.dept_name == this.form2.getFieldValue(
        // 					'company_name')) {
        // 				this.deptlistInput = item.child_lis
        // 			}
        // 		})
        // 		if (this.form2.getFieldValue('dept_id')) {
        // 			get_users2(this.form2.getFieldValue('dept_id'), (res) => {
        // 				this.plainOptions = res
        // 			})
        // 		}
        // 		this.form2.setFieldsValue({
        // 			operator: this.$store.getters.userInfo.userName
        // 		})
        // 	})
        // 	if (res.data.hazard_type) {
        // 		this.form2.setFieldsValue({
        // 			hazard_type: res.data.hazard_type,
        // 		})
        // 		if (res.data.hazard_type.indexOf('其他') != -1) {
        // 			this.elss = res.data.hazard_type.split(';')[res.data.hazard_type.split(';')
        // 				.length - 1]
        // 		} else {
        // 			this.elss = ''
        // 		}
        // 	} else {
        // 		this.elss = ''
        // 	}
        // 	if (res.data.storage_cond) {
        // 		this.form2.setFieldsValue({
        // 			storage_cond: res.data.storage_cond,
        // 		})
        // 		if (res.data.storage_cond.indexOf('其他') != -1) {
        // 			this.others = res.data.storage_cond.split(';')[res.data.storage_cond.split(
        // 				';').length - 1]
        // 		} else {
        // 			this.others = ''
        // 		}
        // 	} else {
        // 		this.others = ''
        // 	}
        // })
      })
    },
    changefalse() {
      this.changevisible = false
    },
    //搜索
    // serchall() {
    // 	this.loading = true
    // 	this.pagination.current = 1
    // 	this.sku_get()
    // },
    //改变分页
    // handleTableChange(pagination, filters, sorter) {
    // 	this.pagination.current = pagination.current
    // 	this.sku_get()
    // },
    // sku_get() {
    // 	sku_spu_get_list({
    // 		page_size: this.pagination.pageSize,
    // 		page_num: this.pagination.current,
    // 		name: this.change.name,
    // 		spu_sn: this.change.id,
    // 		company_id: this.this_dept_id,
    // 	}).then((res) => {
    // 		const pagination = {
    // 			...this.pagination
    // 		}
    // 		pagination.total = res.data.total
    // 		this.pagination = pagination
    // 		this.changedata = res.data.items
    // 		// this.data.forEach((item) => {
    // 		// 	item.price = item.price / 100
    // 		// 	item.value = item.value / 100
    // 		// 	item.amount = item.amount / 100
    // 		// })
    // 	})
    // },
    // changall() {
    // 	this.changevisible = true
    // 	this.sku_get()
    // },
    changeamount() {
      if (this.form2.value != '' && this.form2.value != null) {
        var price = Number(this.form2.value) / Number(this.form2.amount)
        this.form2.purchase_price = price.toFixed(2)
      }
    },
    changeprice() {
      // if (this.form2.getFieldValue('amount')) {
      // 	var price = Number(this.form2.getFieldValue('value') / this.form2.getFieldValue('amount')).toFixed(2)
      // 	this.form2.setFieldsValue({
      // 		purchase_price: price,
      // 	})
      // }
    },
    leaderid2(id) {
      this.$nextTick(() => {
        this.form2.setFieldsValue({
          keeper: undefined,
        })
      })
      dept_get(id).then((res) => {
        this.form2.setFieldsValue({
          charger: res.leader,
        })
      })
      get_users2(id, (res) => {
        this.plainOptions = res
      })
      // get_company_name({
      // 	dept_id: id,
      // }).then((res) => {
      // 	this.form2.setFieldsValue({
      // 		company_name: res.data,
      // 	})
      // })
    },
    checkoutChange2(checkedList) {
      if (checkedList.indexOf('其他') == -1) {
        this.elss = ''
      }
      this.checkList = checkedList
    },
    conditionChange2(checkedList) {
      console.log(checkedList, 'checkedList11111111111111==========================')
      if (checkedList.indexOf('其他') == -1) {
        this.others = ''
      }
      this.checkList2 = checkedList
    },
    Wareprese() {
      this.$refs.form2Ref.validate((valid) => {
        if (valid) {
          console.log(this.form2, 'form2=================================')
          console.log(this.checkList2, 'checkList2===================')
          var value = this.form2
          let resData = {}
          for (let key in value) {
            resData[key] = value[key]
            if (key == 'price' || key == 'value' || key == 'amount' || key == 'purchase_price') {
              resData[key] = value[key]
            }
          }
          resData['item_type'] = 2
          resData['spu_id'] = this.spu_data.spu_id
          console.log(resData, 'resData==============================')
          var data = {
            purchasePrice: resData.purchase_price,
            manufacturer: resData.manufacturer,
            spuId: resData.id,
            spuSn: resData.spu_sn,
            amount: resData.amount,
            arriveTime: resData.arrive_time,
            companyName: resData.company_name,
            createBy: resData.createBy,
            createTime: resData.createTime,
            dealer: resData.dealer,
            deptId: resData.dept_id,
            factoryBatch: resData.factory_batch,
            hazardType: resData.hazard_type,
            inspectCycle: resData.inspect_cycle,
            inspectResult: resData.inspect_result,
            inspectTime: resData.inspect_time,
            isInspected: resData.is_inspected,
            itemType: resData.item_type,
            model: resData.model,
            name: resData.name,
            notes: resData.notes,
            operator: resData.operator,
            price: resData.price,
            purchaseTime: resData.purchase_time,
            spuType: resData.spu_type,
            stableLmt: resData.stable_lmt,
            storageCond: resData.storage_cond,
            storageLoc: resData.storage_loc,
            storageNum: resData.storage_num,
            unit: resData.unit,
            updateBy: resData.updateBy,
            updateTime: resData.updateTime,
            value: resData.value,
          }
          // checkin
          consumablesSku(data).then((res) => {
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.$emit('ok')
              this.Warevisible = false
              this.form2 = {}
              this.selectedRowKeys1 = []
              this.rowData = {}
              // this.form2.resetFields()
              this.get_checkin()
              this.elss = ''
              this.others = ''
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // this.form2.validateFields((err, values) => {
    // if (!err) {
    // if (values['hazard_type']) {
    // 	if (values['hazard_type'].indexOf('其他') > -1) {
    // 		if (this.elss == '') {
    // 			this.elss = '无'
    // 		}
    // 		values['hazard_type'] = this.checkList.join(';') + ';' + this.elss
    // 	} else {
    // 		values['hazard_type'] = this.checkList.join(';')
    // 	}
    // }
    // if (values['storage_cond']) {
    // 	if (values['storage_cond'].indexOf('其他') > -1) {
    // 		if (this.others == '') {
    // 			this.others = '无'
    // 		}
    // 		values['storage_cond'] = this.checkList2.join(';') + ';' + this.others
    // 	} else {
    // 		values['storage_cond'] = this.checkList2.join(';')
    // 	}
    // }

    // .catch(() => {
    // 	this.$message.error('系统错误，请稍后再试')
    // })
    // }
    // })
    // },
    WareCancel() {
      this.$refs.form2Ref.resetFields()
      // this.form2.notes = ''
      this.Warevisible = false
    },
    result() {
      this.quary.companyId = undefined
      this.quary.spuSn = ''
      this.quary.name = ''
      this.quary.spuType = undefined
      // this.name = ''
      // this.asset_sn = ''
      // this.state = undefined
    },
    statechange(value) {
      this.statenum = value
    },
    handleSearchAssetSn(select_asset_sn) {
      this.asset_sn_lis = []
      this.fileList = []
      this.defaultFileList = []
      this.select_asset_index = undefined
      assetget_list2({
        page_size: 10,
        page_num: 1,
        asset_sn: select_asset_sn,
      }).then((res) => {
        console.log(res)
        this.asset_sn_lis = res.data.items
      })
    },
    handleChangeAssetSn(select_asset_sn) {
      this.is_uplaod = false
      // :defaultFileList="defaultFileList"
      this.select_asset_index = this.asset_sn_lis[select_asset_sn].asset_sn
      this.form.setFieldsValue({
        asset_type: this.asset_sn_lis[select_asset_sn].asset_type,
      })
      this.form.setFieldsValue({
        state: this.statusMap[this.asset_sn_lis[select_asset_sn].state],
      })
      this.index = this.asset_sn_lis[select_asset_sn].state
      this.form.setFieldsValue({
        name: this.asset_sn_lis[select_asset_sn].name,
      })
      this.form.setFieldsValue({
        purchase_time: this.asset_sn_lis[select_asset_sn].purchase_time,
      })
      this.form.setFieldsValue({
        purchase_price: this.asset_sn_lis[select_asset_sn].purchase_price,
      })
      this.form.setFieldsValue({
        dealer: this.asset_sn_lis[select_asset_sn].dealer,
      })
      this.form.setFieldsValue({
        model: this.asset_sn_lis[select_asset_sn].model,
      })
      this.form.setFieldsValue({
        dept_id: this.asset_sn_lis[select_asset_sn].dept_id,
      })
      this.form.setFieldsValue({
        charger: this.asset_sn_lis[select_asset_sn].charger,
      })
      this.form.setFieldsValue({
        operator: this.$store.getters.userInfo.userName,
      })
      this.form.setFieldsValue({
        permit: this.asset_sn_lis[select_asset_sn].permit,
      })
      this.form.setFieldsValue({
        keeper: this.asset_sn_lis[select_asset_sn].keeper,
      })

      setTimeout(() => {
        if (this.asset_sn_lis[select_asset_sn].att_path) {
          var att_path = this.asset_sn_lis[select_asset_sn].att_path
          var as = att_path.split(';')
          as.forEach((item, index) => {
            this.fileList.push({
              name,
            })
            this.defaultFileList.push({
              uid: index + 1,
              name: item.split(',')[1],
              status: 'done',
              url: item.split(',')[0],
              response: {
                data: item.split(',')[0],
              },
              type: 'application/pdf',
            })
          })
        } else {
          this.fileList = []
          this.defaultFileList = undefined
          console.log(this.defaultFileList, this.fileList)
          this.$forceUpdate()
        }
        this.is_uplaod = true
      }, 20)
    },
    // 上传各式限制
    beforeUpload(file) {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      this.asset_sn = this.form.getFieldValue('asset_sn')
      this.dept_id = this.form.getFieldValue('dept_id')
      var isType = true
      this.file_name = file.name
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传头文件大小不能超过 10MB!')
      }
      if (file.type != 'application/pdf') {
        isType = false
        this.$message.error('只能上传pdf文件')
      }

      return isLt2M && isType
    },
    //上传文件
    handleChange(info) {
      console.log(info)
      info.fileList.forEach((item, idx) => {
        if (item.type != 'application/pdf') {
          info.fileList.splice(idx, 1)
        }
      })
      if (info.file.status !== 'uploading') {
        // info.fileList.splice(info.fileList.length - 1, 1)
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
        this.fileList.push(info.file.response.data + ',' + info.file.name)
        // info.fileList.push(info.file)
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    //删除文件
    removeFile(file) {
      let data = file.response.data + ',' + file.name
      remove({
        path: file.response.data,
      }).then((res) => {
        console.log(res)
      })
      this.fileList.forEach((item, idx) => {
        if (item == data) {
          this.fileList.splice(idx, 1)
        }
      })
      console.log(this.fileList)
    },
    //预览文件
    previewFile(file) {
      console.log(file)
      window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
    },
    view_path(path) {
      window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + path.split(',')[0])
    },
    onChange(date, dateString) {
      this.start_date = date[0]
      this.end_date = date[1]
    },
    get_checkin() {
      var arry = []
      // fake_sku_list
      // listSku
      consumablesList({
        pageSize: this.pageSize2,
        pageIndex: this.current2,
        companyId: this.quary.companyId,
        spuSn: this.quary.spuSn,
        name: this.quary.name,
        spuType: this.quary.spuType,
        sortField: 'id',
        sortOrder: 'desc',
      }).then((res) => {
        this.total2 = res.data.totalCount
        res.data.list.forEach((item) => {
          var a = {}
          var a = {
            // storageNum
            // spu_type_name: item.spu_type_name,
            storage_num: item.storageNum,
            id: item.id,
            // storage_num: item.storageNum,
            average_price: item.averagePrice,
            is_inspected_name: item.isInspectedName,
            updateTime: item.updateTime,
            updateBy: item.updateBy,
            createTime: item.createTime,
            createBy: item.createBy,
            price: item.price,
            company_name: item.companyName,
            spu_type: item.spuType,
            spu_type_name: item.spuTypeName,
            name: item.name,
            model: item.model,
            amount: item.amount,
            unit: item.unit,
            is_inspected: item.isInspected,
            state: item.state,
            hazard_type: item.hazardType,
            stable_lmt: item.stableLmt,
            factory_batch: item.factoryBatch,
            storage_loc: item.storageLoc,
            storage_cond: item.storageCond,
            purchase_time: item.purchaseTime,
            purchase_price: item.purchasePrice,
            value: item.value,
            arrive_time: item.arriveTime,
            dealer: item.dealer,
            manufacturer: item.manufacturer,
            inspect_time: item.inspectTime,
            inspect_result: item.inspectResult,
            inspect_cycle: item.inspectCycle,
            dept_id: item.deptId,
            charger: item.charger,
            keeper: item.keeper,
            notes: item.notes,
            spu_sn: item.spuSn,
          }
          arry.push(a)
        })
        // this.total = res.data.totalCount
        // this.data = res.data.list
        this.newdata = arry
        console.log(arry, 'arry============')
        console.log(this.data)
        // this.newdata.forEach((item) => {
        // 	item.price = item.price / 100
        // 	item.value = item.value / 100
        // 	item.amount = item.amount / 100
        // item.purchase_price = item.purchase_price / 100
        // item.value = item.value / 100
        // item.amount = item.amount / 100
        // item.price = item.price / 100
        // })
      })
    },
    showSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.get_lis()
    },
    onShowSizeChange(current, pageSize) {
      this.current = current
      this.get_lis()
    },
    showSizeChange2(current, pageSize) {
      this.pageSize2 = pageSize
      this.current2 = current
      this.get_checkin()
    },
    onShowSizeChange2(current, pageSize) {
      this.current2 = current
      this.get_checkin()
    },
    instrtime(time) {
      this.boo = time
    },
    leaderid(id) {
      dept_get(id).then((res) => {
        this.form.setFieldsValue({
          charger: res.leader,
        })
      })
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    add() {
      this.visible = true
      this.form.resetFields()
    },
    add2() {
      Object.assign(this.rowData, {
        value: '',
      })
      var data = JSON.parse(JSON.stringify(this.rowData))
      data.notes = ''
      this.form2 = data
      Object.assign(this.form2, {
        operator: this.$store.getters.userInfo.userName,
      })
      this.Warevisible = true
      console.log(this.form2, 'this.form2========================')

      // this.form2.resetFields()
      // this.selectedRowKeys = []
      // this.$nextTick(() => {

      // this.form2.setFieldsValue({
      // 	operator: this.$store.getters.userInfo.userName
      // })
      // })
      // this.companylist.forEach(item => {
      // 	if (item.dept_name == this.$store.getters.userInfo.company) {
      // 		this.this_dept_id = item.dept_id
      // 	}
      // })
    },
    handleOk(e) {
      setTimeout(() => {
        this.visible = false
        this.loading = false
      }, 2000)
    },
    handleOk2(e) {
      setTimeout(() => {
        this.visible2 = false
        this.loading = false
      }, 2000)
    },
    handleCancel(e) {
      this.visible = false
    },
    handleCancel2(e) {
      this.visible2 = false
    },
    preservation(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          values['item_type'] = 2
          if (this.statenum) {
            values['state'] = this.statenum
          } else {
            values['state'] = this.index
          }
          values['asset_sn'] = this.select_asset_index
          values['att_path'] = this.fileList.join(';')
          var value = values
          let resData = {}
          for (let key in value) {
            resData[key] = value[key]
            if (key == 'purchase_price' || key == 'amount') {
              resData[key] = value[key] * 100
            }
          }
          checkin(resData)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('保存成功')
                this.$emit('ok')
                this.visible = false
                this.get_lis()
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      })
    },
    // preservation2(e) {
    // 	this.form2.validateFields((err, values) => {
    // 		if (!err) {
    // 			console.log(values)
    // 			values['item_type'] = 1
    // 			values['amount'] = values['amount'] * 100
    // 			checkin(values)
    // 				.then((res) => {
    // 					if (res.code === 200) {
    // 						this.$message.success('保存成功')
    // 						this.$emit('ok')
    // 						this.visible2 = false
    // 						this.get_checkin()
    // 					} else {
    // 						values['amount'] = values['amount'] / 100
    // 						this.$message.success(res.msg)
    // 					}
    // 				})
    // 				.catch(() => {
    // 					values['amount'] = values['amount'] / 100
    // 					this.$message.error('系统错误，请稍后再试')
    // 				})
    // 		}
    // 	})
    // },
    query() {
      this.current = 1
      this.get_lis()
    },
    exp() {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      let a = document.createElement('a')
      var state = this.state != undefined ? this.state : ''
      a.href =
        'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkin_records?name=' +
        this.name +
        '&asset_sn=' +
        this.asset_sn +
        '&state=' +
        state +
        '&excel=1'
      a.download = 'test'
      a.click()
    },
    query2() {
      this.current2 = 1
      this.get_checkin()
    },
    exp2() {
      downLoadXlxs2(process.env.VUE_APP_API_BASE_URL + '/daily/consumables/list_excel', {
        pageSize: this.pageSize2,
        pageIndex: this.current2,
        companyId: this.quary.companyId,
        spuSn: this.quary.spuSn,
        name: this.quary.name,
        spuType: this.quary.spuType,
      })
      // get_sku_xlsx({
      // 	page_size: 99999,
      // 	page_num: 1,
      // 	name: this.name2,
      // 	start_date: this.start_date,
      // 	end_date: this.end_date,
      // 	excel: 1
      // })
    },
    handlename(value) {
      console.log(value)
      this.name = value
    },
    details(row) {
      console.log(row, 'row=====================')
      this.detailsvisible = true
      this.detailsrow = row
      console.log(row.att_path)
      this.detailsrow.att_paths = row.att_path ? row.att_path.split(';') : []
    },
    detailsOk() {
      this.detailsvisible = false
    },
    detailsCancel() {
      this.detailsvisible = false
    },
  },
}
</script>

<style>
.content_main_center {
  height: calc(100% - 150px);
}

.dialog {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  margin-bottom: 5px;
}

.center {
  text-align: center;
  width: 832px;
}

.dialog .dialog_item {
  margin-bottom: 5px;
  width: 220px;
  line-height: 32px;
  display: flex;
  justify-content: space-between;
}

.Exhi {
  display: inline-block;
  border: 1px solid black;
  width: 100px;
  text-align: left;
  color: steelblue;
}

.ant-table td {
  white-space: nowrap;
}

.form_item {
  float: left;
  width: 50%;
  height: 50px;
  margin-bottom: 10px;
}

.view_path {
  width: 100%;
  float: left;
  cursor: pointer;
}
.resize-table-th {
  position: relative;
}

.table-draggable-handle {
  /* width: 10px !important; */
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
}
.content_top {
  margin-bottom: 10px;
}
</style>
